import { Row } from 'components/base';
import React, { ComponentType } from 'react';
import { View } from 'react-native';

interface HeaderProps {
  Left?: ComponentType;
  Right?: ComponentType;
}

export const Header: React.FC<HeaderProps> = ({ Left, Right }) => (
  <Row justifyContent="space-between" alignItems="center" flexWrap="wrap">
    {Left ? (
      <View>
        <Left />
      </View>
    ) : (
      <View />
    )}
    {Right && (
      <View>
        <Right />
      </View>
    )}
  </Row>
);
